<template>
  <div>
    <Title
      :title-text="$t('changePasswordForm_change_text')"
      :text="`${$t('changePassword_both_text')}`"
      data-qa="por-change--title" />
    <ChangePasswordForm data-qa="change-password-form" />
  </div>
</template>

<script>
import { track } from '@/services/tracking'

import ChangePasswordForm from '@/components/forms/change'
import Title from '@/components/title'

export default {
  name: 'RequestPassword',
  components: {
    Title,
    ChangePasswordForm
  },
  mounted () {
    track({ name: 'page view', params: { module: 'change password' } })
  }
}
</script>
